import { External } from "components/icons/generated";

import TableCellLink, { TableCellLinkProps } from "./CellLink";

type TableCellRepositoryProps = TableCellLinkProps;

const TableCellRepository = (props: TableCellRepositoryProps) => {
  return <TableCellLink variant="primary" target="_blank" endIcon={External} {...props} />;
};

TableCellRepository.displayName = "DS.Table.CellRepository";

export default TableCellRepository;
